import { Button } from '@/components/Button';

type AuthenticatedButtonsProps = {
  onStartGame: () => void;
  onLogout: () => void;
};

export const AuthenticatedButtons = ({
  onStartGame,
}: AuthenticatedButtonsProps) => {
  return (
    <Button onClick={onStartGame} className="py-[0.8em]">
      スタート
    </Button>
  );
};
